var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.229,5.204C18.059,5.061,17.833,5,17.614,5.042L8.277,6.763C7.921,6.829,7.663,7.139,7.663,7.501v7.277 c-0.399-0.215-0.848-0.348-1.332-0.348c-1.562,0-2.832,1.27-2.832,2.831s1.27,2.832,2.832,2.832s2.832-1.271,2.832-2.832V8.125 L17,6.681v6.192c-0.399-0.215-0.848-0.348-1.332-0.348c-1.562,0-2.831,1.271-2.831,2.832s1.27,2.831,2.831,2.831 s2.832-1.27,2.832-2.831V5.78C18.5,5.557,18.401,5.346,18.229,5.204z M6.332,18.593C5.597,18.593,5,17.995,5,17.261 s0.597-1.331,1.332-1.331s1.332,0.597,1.332,1.331S7.066,18.593,6.332,18.593z M15.668,16.688c-0.734,0-1.331-0.597-1.331-1.331 s0.597-1.332,1.331-1.332S17,14.622,17,15.356S16.402,16.688,15.668,16.688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.738f3cf09f64fbb08bf45ddeeb76f8b9.svg";
export { ForwardRef as ReactComponent };